module.exports = __webpack_public_path__ + "img/resource-tech-image-12.ea3e6255.jpg";